module.exports = __webpack_public_path__ + "static/media/simf (2).6db2658f.jpg";